<template>
    <div>
          <div>字段列表
                <!-- <el-select v-model="chooseFields" multiple placeholder="请选择" style="width: 75%;border-radius: 20px;" @change='selectAll'> -->
                  <el-drag-select v-model="chooseFields" multiple placeholder="请选择" style="width: 75%;border-radius: 20px;" @change='selectAll'>
                     <template v-if="isGroup === true">
                        <el-option-group
                            v-for="group in sourceOptions"
                            :key="group.label"
                            :label="group.label">
                            <el-option
                                v-for="item in group.options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-option-group>
                     </template>
                    <template v-else-if="isGroup === false">
                        <el-option  v-for="item in sourceOptions" :key="item.id" :label="item.label" :style="getStyle(item)" :value="item.id"></el-option>
                    </template>
                <!-- </el-select> -->
                  </el-drag-select>
            </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    import ElDragSelect from '@/components/DragSelect';
    export default {
        components: { ElDragSelect },
        data () {
            return {
                // sourceOptions: [
                //     { id: 'ALL_SELECT', label: 'ALL' },
                //     { id: '1', label: 'liablePerson1' },
                //     { id: '2', label: 'liablePerson2' },
                //     { id: '3', label: 'liablePerson3' },
                //     { id: '4', label: 'liablePerson4' },
                //     { id: '5', label: 'liablePerson5' }
                // ],
                oldOptions: [],
                chooseFields: [],
                myMap: new Map()
            };
        },
        watch: {
            sourceOptions (val) {
                this.initMap();
            }
        },
        props: {
            isGroup: {
                type: Boolean,
                default: false
            },
            sourceOptions: { // 外部传入的下拉列表的结构数据
                type: Array
            },
            selectViewFields: { // 外部传入的下拉列表的结构数据
                type: Array,
                default: () => { return []; }
            }
        },
        created () {
            this.initFields();
        },
        methods: {
            initFields () {
                this.chooseFields = this.selectViewFields;
                this.myMap = new Map();
            },
            getSelectFields () {
                let selectFields = cloneDeep(this.chooseFields);
                if (selectFields.includes('ALL_SELECT')) {
                    selectFields.splice(0, 1); // 排除全选选项
                }
                // console.log(selectFields);
                return selectFields.join(',');
            },
            getSelectViewFields () {
                // let  selectFields=cloneDeep(this.chooseFields);
                if (this.chooseFields.includes('ALL_SELECT')) {
                    this.chooseFields.splice(0, 1); // 排除全选选项
                }
                let selectFieldArr = [];
                this.chooseFields.forEach((field) => {
                    if (this.myMap.has(field)) {
                        selectFieldArr.push(this.myMap.get(field));
                    }
                });
                return selectFieldArr;
            },
            initMap () { // 设置字段的k/v结构
                if (this.isGroup) { // 分组情况
                    this.sourceOptions.forEach((item) => {
                        item.options.forEach((child) => {
                            this.myMap.set(child.id, child);
                        });
                    });
                }
            },
            selectAll (val) {
                // this.setSelectedNode(val);
                const allValues = [];
                // 保留所有值
                for (const item of this.sourceOptions) {
                    allValues.push(item.id);
                }
                // 用来储存上一次的值，可以进行对比
                const oldVal = this.oldOptions.length === 1 ? this.oldOptions[0] : [];
                // 若是全部选择
                if (val.includes('ALL_SELECT')) {
                    this.chooseFields = allValues;
                }
                // 取消全部选中 上次有 当前没有 表示取消全选
                if (oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
                    this.chooseFields = [];
                }
                // 点击非全部选中 需要排除全部选中 以及 当前点击的选项
                // 新老数据都有全部选中
                if (oldVal.includes('ALL_SELECT') && val.includes('ALL_SELECT')) {
                    const index = val.indexOf('ALL_SELECT');
                    val.splice(index, 1); // 排除全选选项
                    this.chooseFields = val;
                }
                // 全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
                if (!oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
                    if (!this.isGroup && val.length === allValues.length - 1) {
                        this.chooseFields = ['ALL_SELECT'].concat(val);
                    }
                }
                // 储存当前最后的结果 作为下次的老数据
                this.oldOptions[0] = this.chooseFields;
            },
            getStyle (item) {
                let single = {
                    'color': '#333'
                };
                if (item.id === 'appCreatedByName' || item.id === 'appCreatedByDate' || item.id === 'processInstanceName' || item.id === 'createdByName' || item.id === 'createdDate') {
                    single.color = '#999';
                }
                return single;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SelectMultiple/SelectMultipleAuth.vue